import { toast } from 'react-toastify';

export const handleApiError = (error) => {
  if (error.response) {
    const statusCode = error.response.status;
    const errorMessage = error.response.data?.message ||
      error.response.data?.error ||
      error.response.data?.msg;

    if (statusCode >= 400 && statusCode < 500) {
      // Client-side errors (400-499) - show backend message
      const message = errorMessage || 'Bad request. Please check your input.';
      toast.error(message);
    } else if (statusCode >= 500) {
      // Server-side errors (500+) - show generic message
      toast.error('Something went wrong. Please try again later.');
    } else {
      toast.error(errorMessage || 'An unexpected error occurred.');
    }
  } else if (error.request) {
    // Network error
    toast.error('Network error. Please check your connection and try again.');
  } else {
    // Other errors
    toast.error('Something went wrong. Please try again later.');
  }

  console.error('API Error:', error);
};